import React, { useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AssumptionsProvider } from './AssumptionsContext';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import "./css/style.css";
import "./charts/ChartjsConfig";
import { AuthProvider } from "./auth/AuthContext";

// Import pages
import Dashboard from "./pages/Dashboard";
import Analytics from "./pages/Analytics";
import Fintech from "./pages/Fintech";
import { StockProvider } from "./StockContext";
import UsersTabs from "./pages/community/UsersTabs";
import Feed from "./pages/community/Feed";
import Forum from "./pages/community/Forum";
import ForumPost from "./pages/community/ForumPost";
import Account from "./pages/settings/Account";
import Notifications from "./pages/settings/Notifications";
import Plans from "./pages/settings/Plans";
import Feedback from "./pages/settings/Feedback";
import Signin from "./pages/Signin";
import Signup from "./pages/Signup";
import SignupSuccess from "./pages/SignupSuccess";
import ResetPassword from "./pages/ResetPassword";
import ButtonPage from "./pages/component/ButtonPage";
import FormPage from "./pages/component/FormPage";
import AlertPage from "./pages/component/AlertPage";
import PaginationPage from "./pages/component/PaginationPage";
import TabsPage from "./pages/component/TabsPage";
import BreadcrumbPage from "./pages/component/BreadcrumbPage";
import BadgePage from "./pages/component/BadgePage";
import TooltipPage from "./pages/component/TooltipPage";
import AccordionPage from "./pages/component/AccordionPage";
import IconsPage from "./pages/component/IconsPage";
import LandingPage from "./pages/LandingPage";
import PrivateRoute from "./auth/PrivateRoutes";
import AdminPanel from "./AdminPanel";
import TermsAndPolicy from "./pages/terms&policy";
import Blog from "./pages/blog";
import Indhold from "./pages/indhold";
import Ivpartner from "./pages/ivpartner";

const stripePromise = loadStripe('pk_live_51Okws8BEGs3qjAhIraHeYYuMLY2MjTf46yDLHzadAKF1eSuveCFdR2wDzLpFKgpkfE9gLCXlzTDRdyOzvWrT13IR00vS9A51PU');

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    document.querySelector("html").style.scrollBehavior = "auto";
    window.scroll({ top: 0 });
    document.querySelector("html").style.scrollBehavior = "";
  }, [location.pathname]);

  return (
    <Elements stripe={stripePromise}>
      <AuthProvider>
        <AssumptionsProvider>
          <StockProvider>
            <div className="w-full overflow-hidden">
              <Routes>
                {/* Public Routes */}
                <Route
                  exact
                  path="/"
                  element={
                    <div className="mt-[80px]">
                      <LandingPage />
                    </div>
                  }
                />
                <Route path="/signin" element={<Signin />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/signup/success" element={<SignupSuccess />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/component/button" element={<ButtonPage />} />
                <Route path="/component/form" element={<FormPage />} />
                <Route path="/component/alert" element={<AlertPage />} />
                <Route path="/component/pagination" element={<PaginationPage />} />
                <Route path="/component/tabs" element={<TabsPage />} />
                <Route path="/component/breadcrumb" element={<BreadcrumbPage />} />
                <Route path="/component/badge" element={<BadgePage />} />
                <Route path="/component/tooltip" element={<TooltipPage />} />
                <Route path="/component/accordion" element={<AccordionPage />} />
                <Route path="/component/icons" element={<IconsPage />} />
                <Route 
                  path="/terms-and-policy" 
                  element={<TermsAndPolicy />}
                />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<Blog />} />
                <Route path="/indhold" element={<Indhold />} />
                <Route path="/ivpartner" element={<Ivpartner />} />

                {/* Protected Routes */}
                <Route element={<PrivateRoute />}>
                  <Route exact path="/dashboard" element={<Dashboard />} />
                  <Route path="/dashboard/analyse" element={<Analytics />} />
                  <Route path="/dashboard/temaer" element={<Fintech />} />
                  <Route path="/community/aktieanalyser" element={<UsersTabs />} />
                  <Route path="/community/feed" element={<Feed />} />
                  <Route path="/community/forum" element={<Forum />} />
                  <Route path="/community/forum-post/:postId" element={<ForumPost />} />
                  <Route path="/community/forum/post/:postId" element={<ForumPost />} />
                  <Route path="/settings/account" element={<Account />} />
                  <Route path="/settings/notifications" element={<Notifications />} />
                  <Route path="/settings/plans" element={<Plans />} />
                  <Route path="/settings/feedback" element={<Feedback />} />
                  <Route path="/admin" element={<AdminPanel />} />
                </Route>

                {/* Catch-all route */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
          </StockProvider>
        </AssumptionsProvider>
      </AuthProvider>
    </Elements>
  );
}

function App() {
  return (
    <AppContent />
  );
}

export default App;